export interface projectDetailsPONumberState {
  projectDetailsPONumber: any | null;
}

export const initialprojectDetailsPONumberState: projectDetailsPONumberState = {
  projectDetailsPONumber: null
};
  